/* Imperia collection pages — no pages.

   Impact paginates the collection grid and renders a "1 / 4" pager. This replaces
   that with one continuous grid: each subsequent page is fetched and appended as
   the shopper approaches the end of the list, so a collection reads as a single
   set of products.

   The theme's own pagination is left in the DOM and only hidden once this script
   has taken over, so a shopper without JS keeps working page links. */
(function () {
  'use strict';

  /* How far before the end of the grid the next page starts loading */
  var LOOKAHEAD = 800;

  var list = null;
  var sentinel = null;
  var observer = null;
  var nextUrl = null;
  var loading = false;

  function nextFrom(root) {
    var link = root.querySelector('.collection__pagination a[rel="next"]');
    return link ? link.href : null;
  }

  /* The buy bar does not open Impact's quick-buy dialog, so appended cards get the
     same ARIA cleanup imperia-cart.js does on load. */
  function stripQuickBuyAria(scope) {
    scope.querySelectorAll('.imperia-buy-bar__button[aria-controls]').forEach(function (button) {
      button.removeAttribute('aria-controls');
      button.removeAttribute('aria-expanded');
    });
  }

  function stop() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (sentinel && sentinel.parentElement) sentinel.parentElement.removeChild(sentinel);
    sentinel = null;
  }

  function nearEnd() {
    if (!sentinel) return false;
    return sentinel.getBoundingClientRect().top < window.innerHeight + LOOKAHEAD;
  }

  function load() {
    if (loading || !nextUrl) return;
    loading = true;

    var url = nextUrl;
    nextUrl = null;

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('product-list.product-list');

        if (incoming) {
          var fragment = document.createDocumentFragment();
          Array.prototype.slice.call(incoming.children).forEach(function (node) {
            fragment.appendChild(document.importNode(node, true));
          });
          stripQuickBuyAria(fragment);
          list.appendChild(fragment);
          /* imperia-cart.js owns buy-bar state. Repaint from the cart it already holds —
             the cart has not changed, so a cart:refresh here would buy nothing and cost a
             /cart.js fetch plus an Impact cart-drawer section re-render on every page. */
          if (window.ImperiaCart && window.ImperiaCart.repaint) {
            window.ImperiaCart.repaint();
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
        }

        nextUrl = nextFrom(doc);
        loading = false;

        if (!nextUrl) {
          stop();
          return;
        }
        /* The appended page may not have filled the viewport — keep going */
        if (nearEnd()) load();
      })
      .catch(function () {
        loading = false;
      });
  }

  function init() {
    var pagination = document.querySelector('.collection__pagination');
    if (!pagination) return;

    list = document.querySelector('product-list.product-list');
    if (!list) return;

    nextUrl = nextFrom(document);
    pagination.style.display = 'none';
    if (!nextUrl) return;

    sentinel = document.createElement('div');
    sentinel.className = 'imperia-collection-end';
    sentinel.setAttribute('aria-hidden', 'true');
    list.parentElement.insertBefore(sentinel, list.nextSibling);

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              load();
              return;
            }
          }
        },
        { rootMargin: LOOKAHEAD + 'px 0px' }
      );
      observer.observe(sentinel);
    } else {
      window.addEventListener('scroll', function () {
        if (nearEnd()) load();
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();